import React from 'react';
import SEO from '../components/SEO';
import '../styles.css';

function AboutPage() {
  return (
    <div className="page-container">
      <SEO 
        title="About Virgil - Professional AI Writing Assistant for Screenwriters"
        description="Virgil brings multiple AI models into one writing workspace for screenplays, novels, podcasts, pitches, and other long-form projects."
        includeStructuredData
        keywords="AI writing software, professional AI writer, screenwriting AI, AI writing company, AI writing technology"
      />
      <section className="content-section static-page-section about-page-section">
        <h1 className="page-title page-title--wide">About Virgil</h1>
        <p className="page-lead page-lead--compact">
          If your passion has ever met the dreaded no, Virgil is for you. We built it to set you free to keep going until the dream is fully realized.
        </p>

        <div className="page-content page-content--polished">
          <div className="static-panel-grid">
            <article className="static-panel">
              <p className="static-panel-kicker">Our Mission</p>
              <h2>For the story that won’t take no for an answer</h2>
              <p>
                Most writers know the moment. You spent months, maybe years, on a script or a manuscript. You brought it to the people with the power to say yes, and they said no. Not because the story was wrong, but because it did not fit their slate, their budget, or their idea of what sells.
              </p>
              <p>
                We built Virgil to free you from that moment. It gives you the tools to keep going on your own terms, from the first outline to the finished draft, the storyboard, and the screen. No committee. No permission slip. Just you and the story, all the way to the end.
              </p>
            </article>

            <article className="static-panel">
              <p className="static-panel-kicker">What We Build</p>
              <h2>Less time on the technology. More time on the story.</h2>
              <p>
                New AI tools show up every week, and each one wants you to learn its quirks. That is time you could spend writing. Virgil brings the best models together in one workspace, so you can stop juggling tabs and get back to the page.
              </p>
            </article>
          </div>

          <article className="static-panel static-panel--wide">
            <p className="static-panel-kicker">The App</p>
            <h2>A home for your next draft, and everything that comes after</h2>
            <p>
              Virgil is writing software from Virgil AI Inc. for screenwriters,
              novelists, and anyone else who tells stories for a living. It puts
              models from OpenAI, Anthropic, Google, and xAI in one app, alongside
              tools for outlining, drafting and revising scenes, screenplay
              formatting, and turning ideas into storyboards, images, and video.
            </p>
            <p>
              Take a look at our <a href="/pricing">plans and pricing</a>,
              browse the <a href="/faq">frequently asked questions</a>, or see
              what’s new in the <a href="/changelog">release notes</a>.
            </p>
          </article>

          <article className="static-panel static-panel--wide">
            <p className="static-panel-kicker">Our Values</p>
            <ul className="values-list values-list--polished">
              <li><strong>Craft:</strong> Structure, pacing, and character come first. The tools are built around them.</li>
              <li><strong>Focus:</strong> Less friction and fewer interruptions, so you can stay in the flow of writing.</li>
              <li><strong>Ownership:</strong> Your words, your choices. Virgil suggests. You decide.</li>
            </ul>
          </article>

          <div className="cta-buttons page-cta-buttons">
            <a href="/signup" className="cta-button">
              Start your 14-day trial
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;

